/* eslint-disable react-hooks/exhaustive-deps */
import { CustomModal } from "./Modal";
import { Button } from "antd";
import { useEffect, useMemo, useState } from "react";
import { playAudio, currencyFormat} from "../utility";
import { useGame } from "../contexts";
import { BoxContainer, ButtonRow } from "./Common";
import { AudioConstant } from "../audio";

export const MarketBox = ({ done }) => {
  const {
    currentPlayer,
    updateHighlightAssets,
    updateSelectedRow,
    selectedRow,
    acceptOffer,
    yourTurn,
    room,
    drawCard,
  } = useGame();
  const [deal, setDeal] = useState(null);
  const [availableAssets, setAvailableAssets] = useState([]);

  const hasSelected = useMemo(
    () => availableAssets.some((x) => x.id === selectedRow?.id),
    [selectedRow, availableAssets],
  );

  // Draw the card once
  useEffect(() => {
    const getDeal = async () => {
      const tempDeal = await drawCard("offer", (card) => (card ? { offer: card } : {}));
      if (!tempDeal) return;
      setDeal(tempDeal);
    };
    if (yourTurn) {
      if (!room?.offer?.name) {
        getDeal();
      }
    } else {
      setDeal(room?.offer || {});
    }
  }, [yourTurn, room?.offer?.name]);

  // Keep available assets in sync with currentPlayer and deal type
  useEffect(() => {
    if (!deal?.type) return;
    const tempHas = (currentPlayer.realEstateAssets || []).filter(
      (x) => x.landType === deal.type,
    );
    setAvailableAssets(tempHas);
    const temp = {};
    tempHas.forEach((item) => (temp[item.id] = "highlighed"));
    updateHighlightAssets(temp);
  }, [currentPlayer.realEstateAssets, deal]);

  const profitLossRes = useMemo(()=>{
    if (hasSelected && deal && availableAssets.length) {
      let totalSellCost;
      if(deal.offerPerUnit)
        totalSellCost =
            deal.offerPerUnit * selectedRow?.units - selectedRow?.cost;
      else {
        totalSellCost = deal?.offer - selectedRow?.cost;
      }

      const type =  totalSellCost > 0 ? "Profit:" : "Loss:"
      return type + " "+ currencyFormat(Math.abs(totalSellCost))
    }

  },[hasSelected,deal,selectedRow])

  return (
    <CustomModal>
      <BoxContainer>
        <div>
          <h2>{deal?.name}</h2>
          <p>{deal?.description}</p>
          <p>{deal?.rule1}</p>
          <p>{deal?.rule2}</p>
          {yourTurn && !availableAssets.length && (
            <p>
              <b>You have no assets that match this opportunity</b>
            </p>
          )}
        </div>
        <div>
            {hasSelected &&  yourTurn && <b> {profitLossRes}</b>}
        </div>
        {yourTurn && (
          <ButtonRow>
            {availableAssets.length > 0 && (
              <Button
                disabled={!hasSelected}
                onClick={() => {
                  acceptOffer(deal, undefined, true);
                  updateSelectedRow(null);
                }}
                block
                type="primary"
              >
                Sell
              </Button>
            )}
            <Button
              type="primary"
              block
              onClick={() => {
                playAudio(AudioConstant.human,currentPlayer);
                done();
              }}
            >
              Done
            </Button>
          </ButtonRow>
        )}
      </BoxContainer>
    </CustomModal>
  );
};
